// THE VR LOOK — the ground (APP_VRSTYLE.md "Ground"). The ground's colour is the GENSURF pool tile alone (gmtex.js
// gmVtTap: the painted class colour × the baked light, sRGB8, ONE trilinear fetch): no near ground block (class
// window, layer blend, detail albedo / normal, hex taps, relight, macro, snow glint, the WAYS-G field) — the
// painter's own ways / sealed flats stay as calm flat shapes. terrain.js asks vrsGroundOn() in _levelBits (every
// level = the tier-0 mask: the pool tap + the bare water term) and takes vrsGroundMap() as the pool's map text.
//
// The tap is SOFTENED: its screen gradients × VRS_SOFT (a coarser mip, ~1.3 levels) — the painted grain goes,
// the class areas and the low-frequency shading (slopes, shadows) stay; a band-limited picture cannot shimmer.
// Saturation × VRS_SAT for the brighter, cleaner flat look. Geometry is untouched (no invented terrain).
import { vrStyleOn } from './index.js';

export const VRS_SOFT = 2.5;    // gradient scale of the pool tap (log2 2.5 ≈ +1.3 mip levels)
export const VRS_SAT = 1.15;    // saturation of the pool colour

export function vrsGroundOn() { return vrStyleOn(); }

// the pool's map text under the style (gmtex.js VT_MAP_GLSL's shape), else `dflt`
export function vrsGroundMap(dflt) {
  if (!vrStyleOn()) return dflt;
  return `
  {
    vec4 sampledDiffuseColor = gmVtTap(gmUv, gmUx * ${VRS_SOFT.toFixed(3)}, gmUy * ${VRS_SOFT.toFixed(3)});
    float vsL = dot(sampledDiffuseColor.rgb, vec3(0.2126, 0.7152, 0.0722));
    sampledDiffuseColor.rgb = max(mix(vec3(vsL), sampledDiffuseColor.rgb, ${VRS_SAT.toFixed(3)}), 0.0);
    diffuseColor *= sampledDiffuseColor;
  }
`;
}

// the program key term (terrain.js attachVariant key): '' off — every other class's key is byte-identical
export function vrsGroundKey() { return vrStyleOn() ? `-vs${VRS_SOFT}s${VRS_SAT}` : ''; }
